import { render, staticRenderFns } from "./UserSysteamInterestChangeActivationType.vue?vue&type=template&id=45ad916b&"
import script from "./UserSysteamInterestChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./UserSysteamInterestChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports